import { ProductAddonGroupCreatePage } from '@/features/product-addon-group/pages/ProductAddonGroupCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon-group/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon_group.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonGroupCreatePage,
})
